module.exports = "<h2>{{'NewProductSOC' | i18next}}</h2>\r\n<div class=\"loader-sx\" style=\"margin-top:20px;\" *ngIf=\"cargandoFormulario\"></div>\r\n<dynamic-form *ngIf=\"!cargandoFormulario\"  [campos]=\"formulario.campos\"></dynamic-form>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/product/configurar.formulario.component.html
// module id = ../../../../../src/app/private/configuracion/product/configurar.formulario.component.html
// module chunks = main